(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aogeo-collection-navigation-v58"]) return;
  try {
    
  (() => {
    const desktop = window.matchMedia('(min-width: 990px)');
    let scheduled = false;

    const buildNavigation = (source) => {
      const heading = source.querySelector('.appillar__section-heading h2');
      const allEquipment = source.querySelector('.appillar__section-heading > a');
      const sourceLinks = source.querySelectorAll('.appillar__series-card');
      if (!heading || sourceLinks.length === 0) return null;

      const navigation = document.createElement('nav');
      navigation.className = 'apcv58-series-nav';
      navigation.setAttribute('aria-label', heading.textContent.trim());
      navigation.dataset.aogeoSeriesNavigationV58 = 'true';

      const head = document.createElement('div');
      head.className = 'apcv58-series-nav__head';

      const title = document.createElement('h2');
      title.textContent = heading.textContent.trim();
      head.append(title);

      if (allEquipment) {
        const allLink = document.createElement('a');
        allLink.className = 'apcv58-series-nav__all';
        allLink.href = allEquipment.href;
        allLink.textContent = allEquipment.textContent.trim();
        head.append(allLink);
      }

      const list = document.createElement('div');
      list.className = 'apcv58-series-nav__list';

      sourceLinks.forEach((sourceLink) => {
        const link = sourceLink.cloneNode(true);
        link.className = 'apcv58-series-nav__link';
        if (sourceLink.classList.contains('is-active')) link.classList.add('is-active');

        const index = link.querySelector('.appillar__series-index');
        const copy = link.querySelector('.appillar__series-copy');
        const arrow = link.querySelector('i');
        if (index) index.className = 'apcv58-series-nav__index';
        if (copy) copy.className = 'apcv58-series-nav__copy';
        if (arrow) arrow.className = 'apcv58-series-nav__arrow';
        list.append(link);
      });

      navigation.append(head, list);
      return navigation;
    };

    const placeNavigation = () => {
      scheduled = false;
      const source = document.querySelector('.appillar--hero .appillar__series');
      if (!source) return;

      const criteria = document.querySelector('.appillar--hero .appillar__criteria');
      const results = document.querySelector('.product-grid-container');
      if (criteria && results && !document.querySelector('[data-aogeo-criteria-lower]')) {
        const lowerSection = document.createElement('section');
        lowerSection.className = 'apcv58-criteria-lower';
        lowerSection.dataset.aogeoCriteriaLower = 'true';

        const inner = document.createElement('div');
        inner.className = 'apcv58-criteria-lower__inner';
        inner.append(criteria);
        lowerSection.append(inner);
        results.after(lowerSection);
      }

      const selector = desktop.matches
        ? '.product-grid-container .facets-block-wrapper--vertical:not(#filters-drawer) > .facets'
        : '#filters-drawer .facets-drawer__filters';
      const host = document.querySelector(selector);
      if (!host || host.querySelector('[data-aogeo-series-navigation-v58]')) return;

      const navigation = buildNavigation(source);
      if (navigation) host.prepend(navigation);
    };

    const schedulePlacement = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(placeNavigation);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeNavigation, { once: true });
    } else {
      placeNavigation();
    }

    desktop.addEventListener('change', schedulePlacement);
    document.addEventListener('shopify:section:load', schedulePlacement);
    new MutationObserver(schedulePlacement).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aogeo-search-page-v57"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-asv57-search-form]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    const value = input?.value.trim() || '';
    if (value.length >= 2) return;
    event.preventDefault();
    input?.setCustomValidity(document.documentElement.lang.toLowerCase().startsWith('zh') ? '请输入至少两个字符。' : 'Enter at least two characters.');
    input?.reportValidity();
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-asv57-search-form] input[name="q"]');
    if (input) input.setCustomValidity('');
  });

  document.addEventListener('click', (event) => {
    const suggestion = event.target.closest('[data-asv57-query]');
    if (suggestion) {
      const section = suggestion.closest('[data-aogeo-search-page-v57]');
      const form = section?.querySelector('[data-asv57-search-form]');
      const input = form?.querySelector('input[name="q"]');
      if (!form || !input) return;
      input.value = suggestion.dataset.asv57Query || '';
      form.requestSubmit();
      return;
    }

    const tab = event.target.closest('[data-asv57-tab]');
    if (!tab) return;
    const section = tab.closest('[data-aogeo-search-page-v57]');
    const target = tab.dataset.asv57Tab;
    section?.querySelectorAll('[data-asv57-tab]').forEach((button) => {
      button.setAttribute('aria-pressed', button === tab ? 'true' : 'false');
    });
    section?.querySelectorAll('[data-asv57-group]').forEach((group) => {
      group.hidden = target !== 'all' && group.dataset.asv57Group !== target;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
